import { TFunction } from 'i18next'

import { LanguageResources } from '@/@types/i18next'
import { UserType } from '../models/user'

export function translateUserType(
  t: TFunction<[LanguageResources]>,
  userType: UserType,
): string {
  switch (userType) {
    case UserType.OWNER:
      return t('common:enums.userType.owner')
    case UserType.ADMIN:
      return t('common:enums.userType.admin')
    case UserType.MEMBERS:
      return t('common:enums.userType.members')
    default:
      return userType
  }
}
